import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Button } from "@material-ui/core";
import { WarningRounded, ArrowBackRounded } from "@material-ui/icons";

const WaitingReceiptApproval = ({ isExternalCheckout = false }) => {
    const history = useHistory();

    return (
        <div className="font-['SF_Pro']">
            <Helmet>
                <title>Aguardando Análise Financeira - Facilita Jurídico</title>
                <meta name="description" content="Seu pagamento foi recebido e está aguardando análise financeira." />
            </Helmet>

            <div className="mt-12 flex flex-col bg-gray-50">
                <main className="flex-1 flex items-center justify-center !px-4 !pb-8 !md:pb-16">
                    <div className="w-full max-w-3xl mx-auto text-center">
                        <div className="!mb-5 md:!mb-6 flex justify-center">
                            <div className="!w-28 !h-28 md:!w-24 md:!h-24 bg-yellow-100 rounded-full flex items-center justify-center !mb-2">
                                <div className="!w-24 !h-24 md:!w-20 md:!h-20 bg-yellow-400 rounded-full flex items-center justify-center">
                                    <WarningRounded className="!w-11 !h-11 md:!w-12 md:!h-12 text-white !text-5xl mb-2" />
                                </div>
                            </div>
                        </div>

                        <div className="text-center !mb-6 md:!mb-9">
                            <h2 className="text-4xl md:!text-5xl font-bold text-slate-900 mb-4 text-balance">
                                Pagamento recebido!
                            </h2>
                            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-50 border border-amber-200">
                                <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse"></span>
                                <span className="text-sm font-medium text-amber-800">
                                    Aguardando análise financeira
                                </span>
                            </div>
                        </div>

                        <div className="space-y-4 !mb-8">
                            <p className="text-base text-slate-600 text-center text-pretty leading-relaxed">
                                Seu pagamento foi processado com sucesso e está sendo analisado pelo
                                nosso setor financeiro.
                            </p>
                            <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
                                <p className="text-sm text-blue-900 text-center leading-relaxed">
                                    <strong className="font-semibold">Não se preocupe!</strong>{' '}
                                    Assim que a análise for concluída, você receberá um e-mail com a
                                    confirmação. Fique à vontade para continuar usando o sistema
                                    enquanto isso.
                                </p>
                            </div>
                        </div>
                        
                        {!isExternalCheckout && (
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                className="w-full sm:w-auto min-w-[200px]"
                                startIcon={<ArrowBackRounded />}
                                onClick={() => {
                                    if (window.location.pathname === '/home') {
                                        return;
                                    }
                                    history.push('/home');
                                }}
                            >
                                Voltar para a plataforma
                            </Button>
                        )}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default WaitingReceiptApproval;